export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-[#d0a24f]/20 to-[#dcb964]/20 rounded-3xl transform rotate-3"></div>
            <img
              src="https://static.readdy.ai/image/0a3008c36638439fa5d134c9c6a19be7/9de5484d29de1aa87cd72addaeac4394.jpeg"
              alt="Dr. Yasir Saeed - Principal Dentist at Beaulieu Dental Chelmsford"
              title="Dr. Yasir Saeed - Expert in Anxious Patient Care"
              className="relative rounded-3xl shadow-2xl w-full h-[500px] object-cover object-top"
            />
          </div>

          <div>
            <h2 className="text-4xl font-bold text-[#444c42] mb-4">
              Meet Dr. Yasir Saeed & Our Team
            </h2>
            <p className="text-lg text-[#7A8178] mb-6 leading-relaxed">
              <strong className="text-[#d0a24f]">Dr. Yasir Saeed</strong> - Principal Dentist
            </p>
            <p className="text-base text-[#7A8178] mb-6 leading-relaxed">
              Dr. Saeed brings over <strong>30+ years of dental expertise</strong> to Beaulieu Dental. His commitment to patient-centered care and advanced techniques has helped thousands of patients achieve optimal oral health.
            </p>
            <p className="text-base text-[#7A8178] mb-8 leading-relaxed">
              Together with our compassionate team, Dr. Yasir specializes in creating a calm, supportive environment where anxious patients feel truly understood and cared for. Every member of our team is trained in anxiety management techniques to ensure your comfort at every visit.
            </p>

            <div className="bg-gradient-to-br from-[#f8f9f8] to-[#f0f1f0] rounded-2xl p-6 mb-8">
              <h3 className="text-xl font-semibold text-[#444c42] mb-4 flex items-center gap-2">
                <i className="ri-award-line text-[#d0a24f] text-2xl"></i>
                Specialties & Expertise
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5"></i>
                  <span className="text-[#7A8178]"><strong>Certified in Sedation Dentistry</strong></span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5"></i>
                  <span className="text-[#7A8178]"><strong>Specialist in Anxious Patient Care</strong></span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5"></i>
                  <span className="text-[#7A8178]">General Dentistry</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5"></i>
                  <span className="text-[#7A8178]">Restorative Dentistry</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5"></i>
                  <span className="text-[#7A8178]">Oral Surgery</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5"></i>
                  <span className="text-[#7A8178]">Dental Implants</span>
                </li>
              </ul>
            </div>

            <div className="flex items-center gap-4 text-[#7A8178]">
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-[#d0a24f] text-2xl"></i>
                <span className="font-semibold">30+ Years Experience</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-team-line text-[#d0a24f] text-2xl"></i>
                <span className="font-semibold">Expert Team</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
